(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('injectParams', function() {
    return {
        restrict: 'A',
        link(scope, el, attr) {
            if (attr.injectParams != null) {
                const obj = JSON.parse(attr.injectParams);
                for (const prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        scope[prop] = obj[prop];
                    }
                }
            }
        }
    };
});
})();
